module.exports = __webpack_public_path__ + "img/removeMark.28fa94c0.svg";